export default __webpack_public_path__ + "static/media/qrcode-site-768w.6ef73f31.webp";